import resetPasswordRoutes from '../containers/ResetPassword';
import acceptInvitationRoutes from '../containers/AcceptInvitation';

const routes = [...resetPasswordRoutes, ...acceptInvitationRoutes];

export default routes;
